import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { libraryParams, normalizeLibraryCode } from "../types/Library";

export default function useMatchUrl() {
  const [isLibray, setIsLibrary] = useState<boolean>();

  const { library } = useParams() as libraryParams;

  const navigate = useNavigate();

  useEffect(() => {
    const result = normalizeLibraryCode(library) !== null;
    if (!result) {
      navigate("/NotFound", { replace: true });
    }
    setIsLibrary(result);
  }, [library, navigate]);

  return isLibray;
}
